<template>
  <section class="title-section min-h-screen">
    <div class="background-container bg-blue-900">
      <img src="images/background.jpg" class="background-image" />
      <img
        src="images/astro-fly.webp"
        class="animated-image"
        v-for="n in numberOfAnimatedImages"
        :key="n"
      />
    </div>
    <div class="logo-container">
      <div class="logo-wrapper">
        <img src="images/text-1.png" class="logo-img" />
      </div>
      <p class="logo-text">First Kitty to the Moon</p>

      <button @click="scrollToAboutSection" id="animatedButton">
        <div class="social-img">
          <img src="images/play-button.png" class="cta-button play-button" />
        </div>
      </button>
      <button @click="addAnimatedImage" id="animatedButton">
        <div class="social-img">
          <img src="images/button-sktm.png" class="cta-button sktm" />
        </div>
      </button>
    </div>

    <div class="ticker-container w-full z-40">
      <TickerComponent :duration="20" />
    </div>
  </section>
</template>

<script>
import TickerComponent from "./TickerComponent.vue";

export default {
  name: "TitlePage",
  components: { TickerComponent },
  data() {
    return {
      numberOfAnimatedImages: 3,
    };
  },

  mounted() {
    this.initAnimations();
  },
  methods: {
    addAnimatedImage() {
      // Check if the current number of images is less than 30
      if (this.numberOfAnimatedImages < 30) {
        this.numberOfAnimatedImages += 1;
        this.$nextTick(() => {
          const animatedImages = this.$el.querySelectorAll(".animated-image");
          const newImage = animatedImages[animatedImages.length - 1];
          if (newImage) {
            this.initSingleAnimation(newImage, animatedImages.length - 1);
          }
        });
      } else {
        // Optional: Alert the user that they've reached the maximum number of images
        alert("Maximum of Kittys allowed");
      }
    },
    scrollToAboutSection() {
      setTimeout(() => {
        const musicPlayer = document.getElementById("musicPlayer");
        musicPlayer.play();
      }, 700); // Adjust the delay as necessary
    },
    initAnimations() {
      const animatedImages = this.$el.querySelectorAll(".animated-image");
      animatedImages.forEach((image, index) => {
        // Give each image a slightly different animation to simulate randomness
        this.initSingleAnimation(image, index);
      });
    },
    initSingleAnimation(animatedImage, index) {
      console.log(index);
      // Initial positions
      let verticalPos = Math.random() * window.innerHeight;
      let horizontalPos = -100; // Start offscreen to the left

      // Speed and direction for vertical and horizontal movements
      let verticalSpeed = 0.5 + Math.random(); // Vertical speed range between 0.5 and 1.5
      let horizontalSpeed = 2 + Math.random() * 5; // Horizontal speed range between 2 and 7
      let verticalDirection = Math.random() > 0.5 ? 1 : -1; // Randomly choose initial vertical direction
      let horizontalDirection = 1; // Always start moving to the right

      const moveImage = () => {
        // Change direction randomly
        if (Math.random() < 0.01) {
          // 1% chance to change vertical direction on each frame
          verticalDirection *= -1;
        }
        if (Math.random() < 0.01) {
          // 1% chance to change horizontal direction on each frame
          horizontalDirection *= -1;
          // Flip the image based on the direction
          animatedImage.style.transform = `scaleX(${horizontalDirection})`;
        }

        // Update positions
        verticalPos += verticalSpeed * verticalDirection;
        horizontalPos += horizontalSpeed * horizontalDirection;

        // Keep the image within the vertical bounds of the window
        if (verticalPos <= 0 || verticalPos >= window.innerHeight) {
          verticalDirection *= -1;
        }

        // Reset horizontal position if the image goes too far left or right
        if (horizontalPos > window.innerWidth + 100 || horizontalPos < -100) {
          horizontalPos = -100; // Restart from the left
          verticalPos = Math.random() * window.innerHeight; // Randomize the vertical start position
          horizontalDirection = 1; // Ensure the image starts moving right again
          animatedImage.style.transform = `scaleX(${horizontalDirection})`;
        }

        // Apply the new positions without overriding the flip transformation
        animatedImage.style.top = `${verticalPos}px`;
        animatedImage.style.left = `${horizontalPos}px`;

        requestAnimationFrame(moveImage);
      };

      moveImage();
    },
  },
};
</script>

<style scoped>
.title-section {
  @apply min-h-screen flex flex-col;
}

.background-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.logo-wrapper {
  position: relative;
  display: inline-block; /* Ensure it wraps the image tightly */
  padding: 10px; /* Adjust padding as needed */
  background-color: rgb(
    0,
    0,
    0,
    0.4
  ); /* Adjust opacity (last value) as needed */
  border-radius: 5px; /* Add rounded corners if desired */
}

.background-container {
  @apply absolute inset-0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}

.logo-container {
  @apply absolute top-[29%] left-[18%] z-10;
  z-index: 10000;
}

.ticker-container {
  @apply mt-auto w-full; /* Add margin-top auto to push it to the bottom */
}

.logo-img,
.logo-text {
  @apply h-20; /* Adjust height as necessary for logo-img */
  @apply text-white font-bold; /* Style for logo-text */
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
    1px 1px 0 black;
}

.logo-img {
  height: 100px;
}

.animated-image {
  @apply absolute;
  width: 100px; /* Adjust based on your image size */
  height: auto;
  z-index: 20; /* Ensure it's above the background image */
  /* Initial position, could be randomized with JavaScript */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Keyframes for horizontal movement */
@keyframes moveX {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

/* Button styling */
#animatedButton {
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
}

#animatedButton:focus {
  outline: none;
}

/* Image styling */
.play-button {
  width: 200px;
}

.sktm {
  width: 300px;
}

.cta-button {
  transition: transform 0.2s ease; /* Smooth transition for transformations */
}

.cta-button {
  transition: transform 0.2s ease; /* Smooth transition for transformations */
}

#animatedButton:hover .cta-button {
  /* Jiggle effect on hover */
  animation: jiggle 0.5s ease infinite;
}

#animatedButton:active .cta-button {
  /* Shrink effect on click */
  transform: scale(0.95);
}

/* Keyframes for jiggle effect */
@keyframes jiggle {
  0%,
  100% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
}
</style>
